import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./IconButton.css.js";
export const IconButton = ({ label, type = "button", children, ...rest }) => (_jsx("button", { type: type, "aria-label": label, className: styles.iconButton, ...rest, children: children }));
//# sourceMappingURL=IconButton.js.map